import {FC, useCallback, useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useSetGameBoxType } from './hoc/useSetGameBoxType';
import Routers from './routing/Routers';
import { setGameInfo } from './store/actionCreators/gameInfo';
import { setGameUrl } from './store/actionCreators/gameUrl';
import { loginSetQueryParams } from './store/actionCreators/queryParams';
import { changeGameBoxView, changeKycStatus, changeLimitsStatus } from './store/actionCreators/ui';
import { getLanguage, getActualLanguage, getTheme } from './store/selectors';
import { clearExpiredProgressiveMissions } from "./store/actionCreators/expiredProgressiveMissions";
import { changeTheme } from "./utils/changeTheme";
import './styles/index.scss';

const App: FC = () => {
  const dispatch = useDispatch();

  const { i18n } = useTranslation();

  const language = useSelector(getLanguage);
  const actualLanguage = useSelector(getActualLanguage);
  //TODO need to merge language and actualLanguage
  const lng = language || actualLanguage;
  const themeParam = useSelector(getTheme);
  const setGameBoxTag = useSetGameBoxType();
  const [manualError, setManualError] = useState<Error | null>(null);


  useEffect(() => {
    if (themeParam) {
      changeTheme(themeParam);
    }
  }, [themeParam]);

  useEffect(() => {
    if (manualError) {
      const errorToThrow = manualError;
      setManualError(null); // reset before throwing
      throw errorToThrow;
    }
  }, [manualError]);

  const handleFrameMessages = useCallback(
      (e: { data: { type: string; gameUrl: string; gameInfo: string; view: string, category: string } | any }) => {
        switch (e.data.type) {
          case 'SET_GAME_URL':
           const { gameUrl, gameInfo } = e.data;
            if (gameUrl) {
              if (gameInfo) {
                dispatch(setGameInfo(gameInfo));
              }
              dispatch(setGameUrl(gameUrl));
              dispatch(changeGameBoxView('game'));
            } else {
              setManualError(new Error('Missing gameUrl'));
            }
            break;
          case 'CHANGE_WIDGET_VIEW':
            const { view, kycStatus, limitsStatus } = e.data;
            dispatch(changeGameBoxView(view));
            dispatch(changeKycStatus(kycStatus));
            dispatch(changeLimitsStatus(limitsStatus));
            break;
          case 'GAME_BOX_CHANGE_LANGUAGE':
            const { language } = e.data;
            i18n.changeLanguage(e.data?.payload?.language ?? language).catch((e) => console.log(e));
            break;
          case 'SET_SELECTED_CATEGORY': {
            const { category } = e.data;
            setGameBoxTag(category);
            break;
          }
          case 'CHANGE_CATEGORY': {
            const { type, category } = e.data;
            window.parent.postMessage({ type: "CLOSE_GAME_BOX" }, "*");
            window.parent.postMessage({ type, category }, "*");
            break;
          }
          case 'GD_LOGIN_ACTION':
            const { payload } = e.data;
            localStorage.removeItem('raceId');
            dispatch(loginSetQueryParams(payload));
            break;
          case 'GD_LOGOUT_ACTION':
            dispatch(changeKycStatus(null));
            dispatch(clearExpiredProgressiveMissions());
            localStorage.removeItem('buttonShown');
            localStorage.removeItem('missionCompleted');
            break;
          default:
            break;
        }
      },
      []
  );

  useEffect(() => {
    i18n.changeLanguage(lng);
  }, [i18n, lng]);

  useEffect(() => {
    window.addEventListener('message', handleFrameMessages);
    return () => window.removeEventListener('message', handleFrameMessages);
  }, [handleFrameMessages]);

  useEffect(() => {
    window.addEventListener('beforeunload', () => {
      localStorage.removeItem('buttonShown');
    });
    window.parent.postMessage({ type: "GAME_BOX_IS_READY" }, "*");
  }, []);
  return (
      <div className="wrapper">
        <Routers />
      </div>
  );
};

export default App;
